import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const PlanCell = styled.div`
    display: flex;
    flex-direction: column;

    color: ${(props) => props.theme.grey};

    & label {
        font: ${theme.font.labelBold};
    }
    
    & span {
        font: ${theme.font.label};
        white-space: nowrap;
    }
`;

export const AlignSelectPlan = styled.div`
    max-width: 516px;
    padding: 32px 0;
`;
